/** @format */
import {TooltipDelta} from 'components/charts/multiline-chart/model/tooltip';

import {CommonChartDataBase, getDeltaByChartType} from './getDeltaByChartType';

interface Options<T> {
  current: T;
  previous?: T;
  roundNumberBy: number;
  token?: string;
  isPositiveRed?: boolean;
}

const getTooltipDelta = <T extends CommonChartDataBase>({
  current,
  previous,
  roundNumberBy,
  token,
  isPositiveRed,
}: Options<T>): TooltipDelta | null => {
  // Если есть предыдущий день, вычисляем дельту

  const isNeedPrimaryDelta = current.primary !== undefined && previous?.primary !== undefined;
  const isNeedSecondaryDelta = current.secondary !== undefined && previous?.secondary !== undefined;

  if (!isNeedPrimaryDelta && !isNeedSecondaryDelta) {
    return null;
  }

  const delta: TooltipDelta = {
    diff: {
      primary: '',
    },
    percent: {
      primary: '',
    },
    diffColor: 'green',
  };

  if (isNeedPrimaryDelta) {
    const {diff, percent, diffColor} = getDeltaByChartType({
      currentPeriodData: current,
      previousPeriodData: previous,
      chartType: 'primary',
      roundNumberBy,
      token,
      isPositiveRed,
    });

    delta.diff.primary = diff;
    delta.percent.primary = percent;
    delta.diffColor = diffColor;
  }

  if (isNeedSecondaryDelta) {
    const {diff, percent} = getDeltaByChartType({
      currentPeriodData: current,
      previousPeriodData: previous,
      chartType: 'secondary',
      roundNumberBy,
      token,
    });

    delta.diff.secondary = diff;
    delta.percent.secondary = percent;
  }

  return delta;
};

export {getTooltipDelta};
